import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {server} from '../server';

export const fetchShortlist = createAsyncThunk(
  'shortlist/fetchShortlist',
  async userId => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(
      `${server}/shortlist/GetShortlistsByUserId?userId=${userId}`,
      {
        headers: {Authorization: token},
      },
    );
    const data = await response.json();
    return data.shortlists || [];
  },
);

export const addShortlist = createAsyncThunk(
  'shortlist/addShortlist',
  async ({userId, shortlistedProfileId}, thunkAPI) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${server}/shortlist/Shortlist`, {
      method: 'POST',
      headers: {Authorization: token, 'Content-Type': 'application/json'},
      body: JSON.stringify({userId, shortlistedProfileId}),
    });

    if (!response.ok) {
      throw new Error('Failed to add shortlist');
    }

    const data = await response.json();
    return data.shortlist || data;
  },
);

export const removeShortlist = createAsyncThunk(
  'shortlist/removeShortlist',
  async shortlistId => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(
      `${server}/shortlist/DeleteShortlist?id=${shortlistId}`,
      {
        method: 'DELETE',
        headers: {Authorization: token},
      },
    );
    if (!response.ok) throw new Error('Failed to remove shortlist');
    return shortlistId;
  },
);

const shortlistSlice = createSlice({
  name: 'shortlist',
  initialState: {
    shortlists: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      // Fetch shortlist
      .addCase(fetchShortlist.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShortlist.fulfilled, (state, action) => {
        state.shortlists = action.payload;
        state.loading = false;
      })
      .addCase(fetchShortlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Add shortlist
      .addCase(addShortlist.pending, state => {
        state.error = null;
      })
      .addCase(addShortlist.fulfilled, (state, action) => {
        if (action.payload) {
          state.shortlists.push(action.payload);
        }
      })
      .addCase(addShortlist.rejected, (state, action) => {
        state.error = action.error.message;
      })

      // Remove shortlist
      .addCase(removeShortlist.pending, state => {
        state.error = null;
      })
      .addCase(removeShortlist.fulfilled, (state, action) => {
        state.shortlists = state.shortlists.filter(
          item => item._id !== action.payload,
        );
      })
      .addCase(removeShortlist.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export default shortlistSlice.reducer;
